import React from 'react';
import { X, Check } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
const comparisonRows = [{
  sin: '3-5 hs/semana buscando rutinas en YouTube',
  con: '10 min/semana mirando la planilla'
}, {
  sin: 'Siempre los mismos ejercicios básicos',
  con: '60+ rutinas y progresiones listas'
}, {
  sin: 'Lesiones por mala técnica',
  con: 'Biomecánica correcta → articulaciones sanas'
}, {
  sin: 'Sin progresión hacia Front/Plancha',
  con: '6 módulos con planificación anual'
}, {
  sin: 'Entrenamiento estancado y frustrante',
  con: 'Adaptación a tu energía del día'
}, {
  sin: 'Entrenamientos siempre iguales',
  con: 'Banco de progresiones por meses'
}, {
  sin: 'Sin saber estructurar descansos',
  con: 'Guías de nutrición, movilidad y recuperación'
}, {
  sin: 'Cero estructura visible de avance',
  con: 'Sistema directo al próximo nivel'
}];
export function ComparisonTable() {
  return <section className="py-10 md:py-16 relative" data-id="element-44">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-45">
        <FadeIn data-id="element-46">
          <div className="text-center mb-5 md:mb-8" data-id="element-47">
            <div className="inline-block bg-brand-orange/10 border border-brand-orange/30 text-brand-orange px-3 py-1 rounded-full text-[10px] md:text-xs font-bold tracking-widest mb-3" data-id="element-48">
              LA REALIDAD
            </div>
            <h2 className="text-2xl md:text-5xl" data-id="element-49">
              ¿Cuánto cuesta{' '}
              <span className="text-brand-orange" data-id="element-50">NO tenerlo?</span>
            </h2>
          </div>

          <div className="bg-brand-card border border-brand-border rounded-2xl overflow-hidden" data-id="element-51">
            <div className="grid grid-cols-2 bg-brand-dark border-b border-brand-border" data-id="element-52">
              <div className="p-2.5 md:p-4 flex items-center gap-2 border-r border-brand-border" data-id="element-53">
                <div className="bg-red-500/15 p-1 rounded" data-id="element-54">
                  <X className="w-3 h-3 md:w-4 md:h-4 text-red-500" data-id="element-55" />
                </div>
                <span className="text-[10px] md:text-sm font-bold text-red-500 uppercase tracking-wider" data-id="element-56">
                  Sin el sistema
                </span>
              </div>
              <div className="p-2.5 md:p-4 flex items-center gap-2" data-id="element-57">
                <div className="bg-brand-orange/15 p-1 rounded" data-id="element-58">
                  <Check className="w-3 h-3 md:w-4 md:h-4 text-brand-orange" data-id="element-59" />
                </div>
                <span className="text-[10px] md:text-sm font-bold text-brand-orange uppercase tracking-wider" data-id="element-60">
                  Con el sistema
                </span>
              </div>
            </div>

            {comparisonRows.map((row, i) => <div key={i} className={`grid grid-cols-2 ${i !== comparisonRows.length - 1 ? 'border-b border-brand-border/60' : ''} ${i % 2 === 0 ? 'bg-brand-card' : 'bg-brand-dark/40'}`} data-id="element-61">
                <div className="p-2.5 md:p-4 text-[11px] md:text-sm text-brand-muted border-r border-brand-border/60 line-through decoration-red-500/30" data-id="element-62">
                  {row.sin}
                </div>
                <div className="p-2.5 md:p-4 text-[11px] md:text-sm text-brand-text font-medium" data-id="element-63">
                  {row.con}
                </div>
              </div>)}
          </div>
        </FadeIn>
      </div>
    </section>;
}